import React from "react";
import { Outlet, Navigate } from "react-router-dom";


const ProtectRoutes = (props) => {
  const user = JSON.parse(localStorage.getItem("User"));
  // const user = "djkfhl"
  return user !== undefined ? (
    user?.role !== undefined ? (
     <><Outlet /></> 
    ) : (
      <Navigate to="/" />
    )
  ) : (
    <Navigate to="/" />
  );
};

export default ProtectRoutes;
